import { ComponentType } from 'react';
import {
  ResourceFieldSelect,
  ResourceFieldSelectProps,
} from 'modules/workflowNodeEditors/editorComponents/ResourceFieldSelect';
import { ResourceType } from 'modules/workflows/constants';
import {
  ResourceListSelect,
  ResourceCustomEventSelect,
  ResourceCampaignSelect,
  ResourceMessageTypeSelect,
  ResourceChannelSelect,
} from '../resourceComponents';
import { ResourceComponentProps } from '../resourceComponents/types';

type FieldComponent =
  | ComponentType<React.PropsWithChildren<ResourceComponentProps>>
  | ComponentType<React.PropsWithChildren<ResourceFieldSelectProps>>;

/**
 * Grabs the resource component to use
 * @param {string} resourceType
 * @returns ComponentType - a populated resource dropfdown
 */
export const getEventResourceField = (resourceType?: ResourceType | null): FieldComponent => {
  switch (resourceType) {
    case ResourceType.List:
      return ResourceListSelect;
    case ResourceType.Campaign:
      return ResourceCampaignSelect;
    case ResourceType.MessageType:
      return ResourceMessageTypeSelect;
    case ResourceType.ProfileField:
      return ResourceFieldSelect;
    case ResourceType.Channel:
      return ResourceChannelSelect;
    case ResourceType.CustomEvent:
      return ResourceCustomEventSelect;
    default:
      return ResourceCustomEventSelect;
  }
};
